import type { Api } from '@cruz-com/lookup'
import _ from 'lodash'
import { round } from 'mathjs'
import { Separator } from '../'

type Props = {
  meta: Api.Meta
} & React.ComponentPropsWithoutRef<'div'>

export default function MetaDisplay({ meta }: Props) {
  return (
    <div>
      <div className='flex items-center gap-x-3 text-sm font-light'>
        <div>
          Total <span className='font-semibold text-base'>{meta?.total_records?.toLocaleString()}</span> Records
        </div>
        {_.toNumber(meta?.total_records_matched) < _.toNumber(meta?.total_records) && (
          <>
            <Separator />
            <div>
              <span className='font-semibold text-base'>{meta?.total_records_matched?.toLocaleString()}</span> Matched
            </div>
          </>
        )}
        {(meta?.total_records_matched || 0) > 0 && (
          <>
            <Separator />
            <div>
              Showing Page <span className='font-semibold text-base'>{meta?.page_number || 1}</span>
              <span> of </span>
              <span className='font-semibold text-base'>{meta?.total_pages?.toLocaleString()}</span>
            </div>
          </>
        )}
      </div>
      {meta?.elapsed_time && (
        <div className='text-sm font-light text-zinc-500 mt-1'>
          <span className='font-medium'>{round(meta.elapsed_time / 1000, 1)}</span> second
        </div>
      )}
    </div>
  )
}
